import React from 'react';

import { useIsLoggedInSession } from './useIsLoggedInSession';
import { useJarabotInsuranceOffer } from './useJarabotInsuranceOffer';

function LoggedInJarabotInsuranceOffer(): null {
	useJarabotInsuranceOffer();

	return null;
}

function JarabotInsuranceOffer(): JSX.Element | null {
	const isLoggedInSession = useIsLoggedInSession();

	if (!isLoggedInSession) return null;

	return <LoggedInJarabotInsuranceOffer />;
}

export default JarabotInsuranceOffer;
